import React, { useContext } from 'react';
import './ImageContainer.scss';
import { S3ImageCollectionT } from '../../utils/s3.helper';
import { isMobile } from '../../utils/app.helper';
import { AppContext } from '../../state/app.state';

type Props = {
    image: S3ImageCollectionT;
    imageFileName?: string;
    className?: string;
    id?: string;
    alt?: string;
}

const ImageContainer: React.FC<Props> = ({ image, id, alt, className }) => {
    const { state } = useContext(AppContext);

    const onLoad = (): void => {
        const currentHeight = document.getElementById('bv-root-element')?.clientHeight;
        state?.pymContextFrame?.sendHeight && currentHeight && state.pymContextFrame.sendHeight(currentHeight);
    };

    const cName = `bv-responsive-image ${isMobile() ? ' bv-responsive-image--mobile ' : ''} ${ className}`;

    return <img
        id={'bv-image-container-id'}
        onLoad={onLoad}
        src={image.large}
        srcSet={`${image.large} 1280w, ${image.medium} 800w, ${image.small} 480w`}
        className={cName}
        alt={alt ? alt : ''}/>;
};

export default ImageContainer;